module.exports = __webpack_public_path__ + "img/female-child-hand.175ea3bd.svg";